import { createFileRoute } from '@tanstack/react-router';

import { HomePage } from '../modules/shift/ui/pages/HomePage';

export const Route = createFileRoute('/_authenticated/queue')({
  component: HomePage,
});
